<div *ngIf="affiliationCodeData">
  <p-checkbox name="affCode" [binary]="true" inputId="affCode"> </p-checkbox>
  <label for="affCode">
    {{ affiliationCodeData.Label }}
  </label>
  <span *ngIf="affiliationCodeData.Required" class="ml-9">*</span>
</div>
